export default __webpack_public_path__ + "ff7304e74e8b30de35bca999e0bf039e.svg";